import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/pro-regular-svg-icons";

import CircularProgress from "@material-ui/core/CircularProgress";

const CollapseIcon = ({ loading }) => {
  return loading ? (
    <CircularProgress size={15} />
  ) : (
    <FontAwesomeIcon icon={faAngleDown} />
  );
};

export default CollapseIcon;
